import React, { useState } from "react";
import { Card, Col, Divider, Image, Popconfirm, Row, Tag } from "antd";
import Link from "antd/es/typography/Link";
import { DeleteOutlined, EditOutlined, SelectOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import {stringToColor} from "../Utils"
import PropTypes from "prop-types";

const { Meta } = Card

function GalleryContactCard(props) {
    const [deleteConfirmShow, setDeleteConfirmShow] = useState(false)

    function handlePhoneNumber() {
        const pnum = props.phone_number
        if (pnum.length === 10) {
            return pnum.substring(0,3) + "-" + pnum.substring(3,6) + "-" + pnum.substring(6,10)
        }
        return pnum
    }

    function handleCityState() {
        if (props.city && props.state) {
            return props.city + ", " + props.state
        } else if (props.state) {
            return props.state
        }
        return null
    }

    function handleTags() {
        if (!props.tags || props.tags === "[") {
            return null
        }
        let arr = [];
        let str1 = props.tags

        if (str1.length > 4) {

            str1 = str1.substring(2, str1.length - 2)
            let textArr = str1.split("','")

            if (textArr.length > 3) {
                arr.push(<Tag color={stringToColor(textArr[0])}>{textArr[0]}</Tag>)
                arr.push(<Tag color={stringToColor(textArr[1])}>{textArr[1]}</Tag>)
                arr.push(<Tag color={stringToColor(textArr[2])}>{textArr[2]}</Tag>)
                var extra = textArr.length - 3
                arr.push(<Tag color={"blue"}>{"+"+extra+"..."}</Tag>)
            } else {
                for (let i = 0; i < textArr.length; i++) {
                    var color = stringToColor(textArr[i])
                    arr.push(<Tag color={color}>{textArr[i]}</Tag >)
                }
            }
            return arr;
        }
        return null
    }

    return (
        <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} key={'GalleryContactCard_' + (props.id ?? "")}>
            <Card
                loading={props.loading}
                style={{ marginBottom: '18px' }}
                bodyStyle={{
                    paddingRight: "18px",
                    paddingLeft: "18px",
                    paddingTop: "18px",
                    paddingBottom: "12px"
                }}
            >
                <Row justify='space-between' align='middle'>
                    <Meta
                        title={
                            <div style={{ width: '100%' }}>
                                <span
                                    style={{
                                        display: 'block',
                                        fontSize: 12,
                                        width: '100%'
                                    }}
                                >
                                    <b>{props.first_name + ' ' + props.last_name}</b>
                                </span>
                            </div>
                        }
                    />
                    <Col>
                    {props.editUrl ? (
                        <Link style={{ color: ' #0531ad' }} href={props.editUrl} target='_blank'
                            rel='noopener noreferrer'>
                            <EditOutlined style={{ fontSize: 16, marginRight: "8px" }} />
                        </Link>
                    ) : null }
                    {props.deleteFunc ? (
                        <Popconfirm
                            key={props.id}
                            title='Are you sure you want to permanently delete it?'
                            onConfirm={() => props.deleteFunc(props.id)}
                            onCancel={() => {}}
                        >
                            <Link style={{ color: 'indianred' }}>
                                <DeleteOutlined
                                    onClick={() => {}}
                                    style={{ fontSize: 16 }}
                                />
                            </Link>
                        </Popconfirm>
                        ) : null}
                    </Col>
                </Row>
                <Divider style={{ marginBottom: "6px", marginTop: "6px", borderTop: '1px solid black' }} />
                <Row style={{ width: "100%" }}>
                    <Tag style={{ marginBottom: "5px" }}>
                        <MailOutlined style={{ marginBottom: "0px", marginTop: "5px" }}/>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                            {props.email ? props.email : "............."}
                        </span>
                    </Tag>
                </Row>
                <Row style={{ width: "100%" }}>
                    <Tag style={{ marginBottom: "5px" }}>
                        <PhoneOutlined style={{ marginBottom: "0px", marginTop: "5px" }} />
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                            {props.phone_number ? handlePhoneNumber() : ".........."}
                        </span>
                    </Tag>
                </Row>
                <Divider style={{ marginBottom: "6px", marginTop: "1px", borderTop: '1px solid gray' }} />
                {handleCityState() ? (
                    <Row style={{ width: "100%" }}>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                            {handleCityState()}
                        </span>
                    </Row>
                ) : (
                    <Row style={{ width: "100%", height: "13px" }}>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                        </span>
                    </Row>
                )}
                {props.country ? (
                    <Row style={{ width: "100%" }}>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                            {props.country}
                        </span>
                    </Row>
                ) : (
                    <Row style={{ width: "100%", height: "13px" }}>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 10
                            }}
                        >
                        </span>
                    </Row>
                )}
                <Divider style={{ marginBottom: "6px", marginTop: "4px", borderTop: '1px solid gray' }}/>
                {(!props.tags || props.tags === "[") ? (
                    <Row style={{ width: "100%", height: "29px" }}>
                        <span
                            style={{
                                width: '100%',
                                fontSize: 20
                            }}
                        >
                        </span>
                    </Row>
                ) : handleTags()}
            </Card>
        </Col>
    )
}

GalleryContactCard.defaultProps = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 8
}

GalleryContactCard.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    index: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
    title: PropTypes.string,
    loading: PropTypes.bool,
    cover: PropTypes.object,
    editUrl: PropTypes.string,
    openUrl: PropTypes.string,
    deleteFunc: PropTypes.func,
}

export default GalleryContactCard